import { createTanstackQueryUtils } from '@orpc/tanstack-query';
import { orpcClient } from './orpc-client';

/**
 * TanStack Query bindings for the whole contract.
 * Usage: `useQuery(orpc.health.get.queryOptions())`, `useMutation(orpc.auth.login.mutationOptions())`.
 */
export const orpc = createTanstackQueryUtils(orpcClient);
